export default "__VITE_ASSET__B5g$MQwi__"